import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "layout-topbar border-bottom-1 surface-border flex align-items-center justify-content-between px-4 py-2 shadow-1" }
const _hoisted_2 = { class: "flex align-items-center gap-3" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "flex align-items-center gap-2 text-color"
}
const _hoisted_6 = { key: 1 }

import { useAuthStore } from "@/stores/AuthStore";
import { useCursoStore } from "@/stores/CursoStore";
import Breadcrumb from "primevue/breadcrumb";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBarDashboard',
  emits: ['toggle-sidebar'],
  setup(__props, { emit: __emit }) {

const route = useRoute();
const router = useRouter();
const emit = __emit;
const authStore = useAuthStore();
const cursoStore = useCursoStore();

const breadcrumbItems = computed(() => {
  const currentPath = route.path;
  const items: { label?: string; icon?: string; route?: string }[] = [
    {
      label: 'Home',
      icon: 'fa-solid fa-house',
      route: currentPath === '/' ? '' : '/'
    }
  ];

  if (route.path.includes('/eventos')) {
    items.push({ label: 'Eventos', route: currentPath === '/eventos' ? '' : '/eventos' });
  } else if (authStore.isAluno || authStore.isUserNormal) {
    if (route.path.includes('/acompanhamento')) {
      items.push({ label: 'Acompanhamento', route: currentPath === '/acompanhamento' ? '' : '/acompanhamento' });
    } else {
      items.push({ label: 'Meus Projetos', route: currentPath === '/projetos' ? '' : '/projetos' });
    }
  } else if (authStore.isOrientador) {
    if (route.path.includes('/defesas')) {
      items.push({ label: 'Revisão de Defesas', route: currentPath === '/defesas' ? '' : '/defesas' });
    } else {
      items.push({ label: 'Painel do Orientador', route: currentPath === '/painel-orientador' ? '' : '/painel-orientador' });
    }
  } else if (authStore.isCoordenador || authStore.isSecretaria || authStore.isCoordenadorTcc) {
    if (route.path.includes('/gerenciar-professores')) {
      items.push({ label: 'Gerenciar Professores', route: currentPath === '/gerenciar-professores' ? '' : '/gerenciar-professores' });
    } else if (route.path.includes('/avisos')) {
      items.push({ label: 'Central de Avisos', route: currentPath === '/avisos' ? '' : '/avisos' });
    } else if (route.path.includes('/gerenciar-normas-tcc')) {
      items.push({ label: 'Normas TCC / Links', route: currentPath === '/gerenciar-normas-tcc' ? '' : '/gerenciar-normas-tcc' });
    } else {
      items.push({ label: 'Gerenciar Trabalhos', route: currentPath === '/gerenciar-trabalhos' ? '' : '/gerenciar-trabalhos' });
    }
  } else if (authStore.isAdmin) {
    items.push({ label: 'Administração do Sistema', route: currentPath === '/admin' ? '' : '/admin' });
  }

  if (route.name === 'editor' || route.name === 'orientador-editor') {
    items.push({ label: 'Editor', route: '' });
  } else if (route.name === 'acompanhamento-detalhes' || route.name === 'coordenador-trabalho-detalhes') {
    items.push({ label: 'Detalhes', route: '' });
  } else if (route.name === 'referencias') {
    items.push({ label: 'Gerenciar Referências', route: '' });
  } else if (route.name === 'admin-templates') {
    items.push({ label: 'Gerenciar Templates', route: '' });
  } else if (route.name === 'admin-roles') {
    items.push({ label: 'Gerenciar Perfis', route: '' });
  } else if (route.name === 'admin-permissions') {
    items.push({ label: 'Gerenciar Permissões', route: '' });
  } else if (route.name === 'admin-users') {
    items.push({ label: 'Gerenciar Usuários', route: '' });
  } else if (route.name === 'admin-cursos') {
    items.push({ label: 'Gerenciar Cursos', route: '' });
  } else if (route.name === 'admin-coordenadores') {
    items.push({ label: 'Gerenciar Coordenadores', route: '' });
  } else if (route.name === 'admin-secretarias') {
    items.push({ label: 'Gerenciar Secretárias', route: '' });
  } else if (route.name === 'admin-professores') {
    items.push({ label: 'Gerenciar Professores', route: '' });
  } else if (route.name === 'admin-alunos') {
    items.push({ label: 'Gerenciar Alunos', route: '' });
  }

  if (route.name === 'conta') {
    return [
      { icon: 'pi pi-home', route: '/' },
      { label: 'Minha Conta', route: '' }
    ];
  }

  if (route.name === 'tutoriais') {
    return [
      { icon: 'pi pi-home', route: '/' },
      { label: 'Tutoriais', route: '' }
    ];
  }

  return items;
});

const navigateTo = (item: any) => {
  if (item.route) {
    router.push(item.route);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Breadcrumb), {
        model: breadcrumbItems.value,
        class: "border-none p-0 bg-transparent gap-2 mb-2 mt-2"
      }, {
        item: _withCtx(({ item }) => [
          (item.route)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "cursor-pointer flex align-items-center gap-2 hover:text-primary transition-colors transition-duration-200 text-primary",
                onClick: _withModifiers(($event: any) => (navigateTo(item)), ["prevent"])
              }, [
                (item.icon)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(item.icon)
                    }, null, 2))
                  : _createCommentVNode("", true),
                (item.label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.label), 1))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                (item.icon)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(item.icon)
                    }, null, 2))
                  : _createCommentVNode("", true),
                (item.label)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.label), 1))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})